"use server";

import { requireServerRole } from "@/lib/guards";
import {
  addRestrictedCathrinUserSchema,
  editRestrictedCathrinUserSchema,
  deleteRestrictedCathrinUserSchema,
} from "@/lib/schemas/restricted-cathrin-users";
import { validateParams } from "@/lib/utils";
import { prisma } from "@/prisma";
import z from "zod";
import { GRP_ROLE_ADMIN } from "@/lib/grp";
import { ActionResult } from "@/types/server-action";

export async function deleteRestrictedCathrinUser(
  params: z.infer<typeof deleteRestrictedCathrinUserSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const { id } = validateParams(deleteRestrictedCathrinUserSchema, params);

    await prisma.restrictedCathrinUser.update({
      where: { id },
      data: { deletedAt: new Date() },
    });

    return { success: true };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}

export async function addRestrictedCathrinUser(
  params: z.infer<typeof addRestrictedCathrinUserSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const { user, functionality } = validateParams(
      addRestrictedCathrinUserSchema,
      params,
    );

    const restrictedCathrinUser = await prisma.restrictedCathrinUser.create({
      data: {
        user,
        functionality,
        isActive: true,
      },
    });

    return { success: true, data: restrictedCathrinUser };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}

export async function editRestrictedCathrinUser(
  params: z.infer<typeof editRestrictedCathrinUserSchema>,
): Promise<ActionResult> {
  await requireServerRole([GRP_ROLE_ADMIN]);
  try {
    const {
      id = -1,
      user,
      functionality,
      isActive = true,
    } = validateParams(editRestrictedCathrinUserSchema, params);
    const restrictedCathrinUser = await prisma.restrictedCathrinUser.update({
      where: { id },
      data: { user, functionality, isActive },
    });

    return { success: true, data: restrictedCathrinUser };
  } catch (error) {
    console.error(error);

    return {
      success: false,
      message: "Une erreur serveur est survenue.",
    };
  }
}
